export const en = {
  aiPlayground: {
    pageTitle: 'Training',
    admin: {
      intro: {
        labelComingSoon: 'Coming soon',
        title: 'Tailored Training',
        description:
          'Customized training creates personalized growth paths. Starting from the soft skills assessment, each user receives targeted suggestions aligned with their profile, making development more effective and engaging.',
        comingDate: 'Expected launch: Q1 2026',
      },
      pillars: {
        block1: {
          title: 'Personalized paths',
          description:
            'Training built on assessment results, with content tailored in format and duration.',
        },
        block2: {
          title: 'Content library',
          description:
            'Over 300 resources including videos, podcasts, workshops, in-person courses, and interactive articles.',
        },
        block3: {
          title: 'AI & Analytics',
          description:
            'AI selects and validates content, provides targeted recommendations, and updates progress in dashboards.',
        },
      },
      howDoesItWork: {
        title: 'How it works',
        step1: {
          title: 'View the paths',
          description: 'Discover the training paths best suited to improve your profile.',
        },
        step2: {
          title: '2. Results analysis',
          description:
            'Advanced dashboards and analytics show the evolution of skills at both individual and team levels.',
        },
        step3: {
          title: 'Receive AI recommendations',
          description: 'Personalized suggestions based on usage and performance data.',
        },
      },
      catalog: {
        title: 'Activity catalog',
        step1: {
          title: 'Free Resources',
          description:
            'An open section that gathers free content on soft & hard skills, designed to introduce employees to training.',
        },
        step2: {
          title: 'Slash online courses',
          description:
            'Training pills of 5-10 minutes, quizzes, podcasts, and practical micro-challenges. Ideal for quick and continuous learning, adaptable to work rhythms.',
        },
        step3: {
          title: 'Exclusive content',
          description:
            'Premium events and webinars with experts, immersive experiences, and valuable storytelling offered by selected partners.',
        },
        step4: {
          title: 'In-person courses',
          description:
            'Workshops and live lessons that enrich the digital path with experiential moments and direct interaction.',
        },
      },
      gamification: {
        title: 'Gamification',
        description:
          'The platform encourages participation with a gamification system that rewards consistency, collaboration, and results. Challenges, leaderboards, and prizes make the training experience more motivating and engaging.',
        block1: {
          title: 'Leaderboard',
          description: 'Rankings and challenges to foster positive competition',
        },
        block2: {
          title: 'Rewards and content unlocking',
          description: 'Credits earned allow access to exclusive content or special events.',
        },
        block3: {
          title: 'Badges and certifications',
          description: 'Recognition and certificates upon reaching milestones',
        },
      },
      aiPlayground: {
        title: 'AI Playground',
        subTitle: 'Start training your teams today with AI Playground',
        description:
          'While waiting for platform Training, explore the AI Playground by altermAInd: strategic and practical experiences to introduce artificial intelligence into your company, enhancing people, skills, and a growth mindset.',
        buttonText: 'Discover the program',
      },
      landingPlayground: {
        people: 'people',
        person: 'person',
        title: 'AI Playground paths for your organization',
        description:
          'Discover the AI Playground by altermAInd: strategic and practical paths to introduce artificial intelligence into your company. The customized module transforms questionnaires into tailored growth plans, enhancing soft skills and offering targeted suggestions for effective and engaging development.',
        buttonText: 'Discover the program',
        courses: {
          title: 'Our courses',
          tooltip:
            'Marked with “Skill to boost” are the two skills in your organization that scored the lowest on average. The number next to the heart indicates how many employees showed interest in each course.',
          card: {
            skillToBoost: 'Skill to boost',
            initialLevel: 'Initial level',
            participant: 'Persona',
            participants: 'Persone',
            partecipanesTooltip: 'People who scored between 0 and 2 in this skill',
            departments: 'Departments',
            departmentsTooltip: 'Number of departments where people with initial level belong',
            buttonLabel: 'Learn more',
          },
          detailsDialog: {
            label: 'COURSE',
            description: 'Description',
            buttonLabel: 'Download the brochure',
          },
          usersContentsLikesDialog: {
            title: 'Interested employees',
            description: 'View employees interested in the AI Playground activity',
            table: {
              fullName: 'Full Name',
              role: 'Role',
              email: 'Email',
            },
            labelAllEmployees: 'All employees',
          },
        },
        aiPlayground: {
          noResult: {
            title: 'AI Playground',
            subTitle: 'Do you want your employees to experience the AI Playground?',
            subTitleSkill:
              'Are your employees struggling with {{name}}?\nActivate the most suitable path now',
            description: 'Find out how to start the most suitable path for your organization!',
            descriptionSkill:
              'The assessment shows that {{count}} {{personLabel}} in the company have an initial level in {{name}}.\n Contact us and start the AI Playground training best suited to strengthen this skill.',
            buttonLabel: 'Contact us',
          },
        },
      },
    },
    learning: {
      tutorial: {
        title: 'Discover how soft skills training works',
        slides: {
          slide1: {
            title: 'Explore soft skills',
            description:
              'Browse the list of available soft skills. Based on your personal assessment results, some skills may be highlighted as "Skill to boost": these are the ones where your score is lowest and represent the areas with the greatest growth potential.',
          },
          slide2: {
            title: 'Discover available activities',
            description:
              'For each soft skill, you can view the associated in-person training activities. You can also express a preference for the activities that interest you; this will be automatically communicated to HR, who can take it into consideration when organizing potential in-person training days for the company.',
          },
        },
      },
      landingPlayground: {
        people: 'people',
        person: 'person',
        title: 'Do your skills need a boost?',
        description:
          'On this page, you’ll find the AI Playground by altermAInd paths best suited to start training those skills, with engaging, practical activities focused on real impact. To learn more about the modules, download the full brochure by clicking Discover the program.\n\n Once you complete the assessment, we’ll highlight the skills where you scored the lowest, so you can select the AI Playground modules best suited to improve them.',
        buttonText: 'Discover the program',
        courses: {
          title: 'Our courses',
          tooltip:
            'Marked with “Skill to boost” are the two skills in your Actual profile where you scored the lowest overall.',
          card: {
            skillToBoost: 'Skill to boost',
            buttonLabel: 'Learn more',
          },
          detailsDialog: {
            label: 'COURSE',
            description: 'Description',
            buttonLabel: 'Download the brochure',
          },
        },
        programs: {
          title: 'Experiential paths to train your skills',
          description:
            'Each AI Playground module offers three different types of activities designed to train soft skills from multiple angles. You can choose between quick content, dynamic stimuli, and immersive challenges: download the full brochure for more information.',
          blocks: {
            block1: {
              title: 'Short pills',
              description:
                'Quizzes, AI tools, and micro-content perfect for activating your mind, discovering new approaches, and acquiring immediately applicable tools.',
            },
            block2: {
              title: 'Dynamic corners',
              description:
                'Mini-sessions led by mentors, designed to show you skills “in action.” A concrete way to spark ideas and turn concepts into practice.',
            },
            block3: {
              title: 'Game day',
              description:
                'Escape rooms, timed challenges, and simulations. Learn by doing, train your mindset, and test your reactions.',
            },
          },
        },
        aiPlayground: {
          title: 'AI Playground',
          subTitle: 'Do you want to join one or more AI Playground modules?',
          description:
            'Show your interest with a “like”: HR will see your preferences and can activate the most relevant paths for you.',
          buttonLabel: 'Contact us',
        },
      },
    },
  },
};
